import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { SupervisoryInstitution } from '../../../../../../api/types/settings/studies/supervisory-institution';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const saveNewSupervisoryInstitution = async (
  institutionName: string,
  setLoading: (isLoading: boolean) => void,
  onHide: () => any,
) => {
  try {
    if (!institutionName && institutionName.length === 0) {
      toast.warn(`יש להזין את גוף מפקח`);
      console.warn(`Assignment type name must not be empty`);
      return;
    }
    if (institutionName && institutionName.length < 3) {
      toast.warn('על גוף המפקח להיות באורך של למעלה משלושה תווים');
    }
    const existingInstitution =
      globalSettingsStores.supervisoryInstitution.find(
        (item) => item.institutionName === institutionName,
      );
    if (existingInstitution) {
      toast.warn('שם גוף מפקח כבר קיים במערכת');
      return;
    }
    if (institutionName && institutionName.length > 50) {
      toast.warn('על גוף המפקח להיות באורך של לא יותר מחמישים תווים');
      return;
    }
    setLoading(true);
    const res = await appApi.addSupervisoryInstitution(institutionName);
    if (!res.data.ok || !res.data.body) {
      throw new Error('An error occurred');
    }
    const newInstitution: SupervisoryInstitution = res.data.body;
    globalSettingsStores.supervisoryInstitution.push(newInstitution);
    setLoading(false);
    toast.success(`הוספת ${institutionName} התבצעה בהצלחה`);
    onHide();
  } catch (e) {
    setLoading(false);
    console.error(
      `Failed to create new supervisoryInstitution with the institutionName: ${institutionName} and the error: ${e}`,
    );
    toast.error('הפעולה נכשלה נסה שוב בעוד מספר רגעים');
  }
};
